/**
 * components/team/roleKey.js
 * The key a custom role is saved under, derived from the name the owner types
 * ("Night cashier" -> NIGHT_CASHIER). Mirrors normalizeCustomRoleKey in
 * services/vendorTeam/vendorTeamRbacService.js; the server derives the same
 * key itself, so this is only for showing it before saving.
 */
export const roleKeyFromName = (name) => {
  const k = String(name || "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 30);
  return /^[A-Z][A-Z0-9_]{1,29}$/.test(k) ? k : "";
};

export default roleKeyFromName;
